import * as React from 'react'

import FooterItem from '@/components/Footer/FooterItem'

const FooterColumn = ({groups}) => {
  return groups.length === 0 ? null : (
    <ul>
      {groups.map(({_uid, heading, items = []}) => {
        return (
          <li key={_uid} className='mb-8 flex flex-col gap-2 text-white'>
            <span className='body-m-bold mb-6'>{heading}</span>
            {items.length > 0 &&
              items.map((item) => {
                return <FooterItem key={item._uid} {...item} theme='light' />
              })}
          </li>
        )
      })}
    </ul>
  )
}

export default FooterColumn
